import React from "react";
import styles from "./VoiceHero.module.css";
import { Phone, ArrowRight, Sparkles } from "lucide-react";
import heroImg from "../../../Images/wwm9lceq.png";

const VoiceHero = () => {
    return (
        <section className={styles.hero}>
            <div className={styles.container}>

                {/* LEFT CONTENT */}
                <div className={styles.left}>
                    <span className={styles.badge}>
                        <Sparkles size={14} />
                        Voice AI Agents
                    </span>

                    <h1 className={styles.title}>
                        Calls That <br />
                        <span>Sound Human</span>
                    </h1>

                    <p className={styles.description}>
                        Deploy AI voice agents that handle thousands of calls
                        simultaneously with the warmth, empathy, and intelligence
                        of your best human agents. Powered by Vox.
                    </p>

                    <div className={styles.actions}>
                        <button className={styles.primaryBtn}>
                            <Phone size={16} />
                            Request Demo
                        </button>

                        <button className={styles.secondaryBtn}>
                            Explore Capabilities
                            <ArrowRight size={16} />
                        </button>
                    </div>
                </div>

                {/* RIGHT IMAGE */}
                <div className={styles.right}>
                    <img src={heroImg} alt="Voice AI Demo" />
                </div>
            </div>
        </section>
    );
};

export default VoiceHero;